module.exports = __webpack_public_path__ + "packs/media/images/image_cooking-e8763ce13da640e0c27728f199bcfb7d.png";